import React from 'react';
import { motion } from 'framer-motion';
import { scrollToPricing } from './utils';
export function MidCTA() {
  return <section className="py-12 px-4 bg-mystic-800 relative overflow-hidden" data-id="element-168">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-lilac-500/10 via-mystic-800 to-mystic-800 pointer-events-none" data-id="element-169" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-170">
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={scrollToPricing} className="w-full sm:w-auto px-8 py-5 bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-mystic-900 font-bold text-lg md:text-xl rounded-full shadow-[0_0_40px_rgba(212,175,55,0.4)] transition-all" data-id="element-171">
          👉 BASTA DE MIGAJAS — QUIERO MI MEGAPACK AHORA
        </motion.button>
      </div>
    </section>;
}